import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";
import IconButton from "components/icon-button";
import withStyles from "components/with-styles";
import styles from "./styles/menu-close-icon.css.js";
import Icon from "components/icon";

const MenuCloseIcon = ({ classes, onClick, open }) => (
  <IconButton
    edge="start"
    color="inherit"
    onClick={onClick}
    className={cn(classes.dashboard_header_menuButton, open && classes.dashboard_header_menuButton__hidden)}
  >
    <Icon name="menu" />
  </IconButton>
);

MenuCloseIcon.propTypes = {
  /**
   * Indica si el menú lateral del dashboard está desplegado
   **/
  open: PropTypes.bool,
  /**
   * Handler que se llama al clicar el botón de desplegar o cerrar el dashboard
   **/
  onClick: PropTypes.func,
};

export default withStyles(styles)(MenuCloseIcon);
